export default "__VITE_ASSET__DjvS5IFz__"